export default __webpack_public_path__ + "static/ely-8-38a5dedae49e66507fd831035bc5348f.jpg";